const main_menu = [
  {
    id: 1,
    name: "Home",
    path: "/",
  },
  {
    id: 2,
    name: "About Us",
    path: "/the-club",
  },
  {
    id: 4,
    name: "Bookshelf",
    path: "/books",
  },
  {
    id: 5,
    name: "Currently Reading",
    path: "/currently-reading",
  },
  {
    id: 6,
    name: "Community",
    path: "https://discord.gg/pc2pqxwtHV",
  },
  {
    id: 7,
    name: "Join Now",
    path: "/join-now",
  },
  {
    id: 8,
    name: "Manage subscription",
    path: "https://billing.stripe.com/p/login/cNibJ3bfQ9cr6455mfejK00",
  },
];

export { main_menu };
